module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"qualifications":{"action":"Add qualifications","empty_state":"Add your acquired qualifications to increase your trustworthiness even further.","title":"Qualifications"}}}}}}}')
  delete Component.options._Ctor
}
